<template>
    <div>
    <v-dialog v-model="visualizar" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ contrato.descripcion }}</span>
          <v-spacer></v-spacer>
         
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="contrato.licitacion" label="Nombre" required outlined></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="contrato.descripcion" label="Descripcion" required outlined></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="contrato.mandante" label="Mandante" outlined></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-select :items="clientes" v-model="contrato.cliente" label="Cliente" outlined></v-select>
              </v-col>
              <v-col cols="3">
                <v-select :items="contactos" v-model="contrato.contacto" label="Contacto" outlined></v-select>
              </v-col>
              <v-col cols="3">
                <v-select :items="servicios" v-model="contrato.servicio" label="Servicio" outlined></v-select>
              </v-col>                            
 
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import api from "../conf/ruta-base"
import moment from "moment";
import axios from 'axios';
import swal from "sweetalert";
moment.locale('es');
export default {
    data() {
        return {
            contrato:{},
            contratoDefault: {},
            contactos:[],
            clientes:[],
            servicios:[]
        }
    },
  props: {
    editedItem: {
      type: Object,
      default: null
    },
    editedIndex: {
        type: Number,
        default: -1
    },
    visualizar: {
        type: Boolean,
        default: false,
    }
  },
  watch:{
    editedItem(data){
        if(data) this.cliente = data;
    },
  },
  methods: {
    //Metodo que se trae la informacion de la fecha formato mysql y la retorna local
    momento(fecha){
      return moment(fecha).format('L')
    },
    //empuja el archivo al componente padre
    onFileCharge(){
        this.$emit('cargaArchivos',this.chosenFile)
        this.chosenFile = null
    },
    close(){
        this.$emit('close',false)
    },
    presave(){
        if(!this.contrato.licitacion || !this.contrato.descripcion || !this.contrato.mandante) {
            swal('','Los campos de identificacion son obligatorios','error'); return;
        }
        if(!this.contrato.cliente || !this.contrato.contacto || !this.contrato.servicio) {
            swal('','Los campos de relacion son obligatorios','error'); return;
        }

        if(this.editedIndex == -1){
            axios.post(`${api.api}contratos`,this.contrato).then(res=>{
                this.$emit('cargaContratos',res.data)
                this.$emit('close',false)
                swal('','Cliente guardado','success');
            }).catch(err=>{
                swal('','Error al guardar Cliente','error');
            })
        }else{
            axios.put(`${api.api}contratos/${this.contrato.id}`,this.contrato).then(res=>{
                this.$emit('cargaContratos',this.contrato)
                //this.$emit('close',false)
                swal('','Cliente actualizado','success');
            }).catch(err=>{
                swal('','Error al actualizar Cliente','error');
            })
        }
    },
  },
  mounted(){
    axios.get(`${api.api}clientes`).then(res=>{
        res.data.forEach(cliente => {
          this.clientes.push({text: `${cliente.razonSocial} - ${cliente.giro}`, value: cliente.id})
        });
    }).catch(err=>{
        swal('','Error al traer los datos de clientes.','error');
    })

    axios.get(`${api.api}contactos`).then(res=>{
        res.data.forEach(contactos => {
          this.contactos.push({text: `${contactos.nombre} - ${contactos.cargo}`, value: contactos.id})
        });
    }).catch(err=>{
        swal('','Error al traer los datos de los contactos','error');
    })
    
    axios.get(`${api.api}servicios`).then(res=>{
        res.data.forEach(servicio => {
          this.servicios.push({text: `${servicio.nombre} - ${servicio.descripcion}`, value: servicio.id})
        });
    }).catch(err=>{
        swal('','Error al traer los datos de servicios','error');
    })    
  }
}
</script>